var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", [_vm._v("Courses")]),
      _vm._v(" "),
      _c("CourseSearchCardsMobile", {
        attrs: { courses: _vm.courses, queryID: _vm.queryID, startPosition: 1 }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }